/**
 * Local wishlist (localStorage) for product cards.
 */
(function () {
  const KEY = 'pi_wishlist_v1';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (_) {}
  }

  function isSaved(id) {
    return read().some((item) => String(item.id) === String(id));
  }

  function toggle(btn) {
    const id = btn.dataset.productId;
    if (!id) return;
    let list = read();
    const exists = list.find((item) => String(item.id) === String(id));
    if (exists) {
      list = list.filter((item) => String(item.id) !== String(id));
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    } else {
      list.push({
        id,
        title: btn.dataset.productTitle || '',
        url: btn.dataset.productUrl || '#',
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    }
    write(list);
  }

  function syncButtons() {
    document.querySelectorAll('[data-pi-wishlist-toggle]').forEach((btn) => {
      const on = isSaved(btn.dataset.productId);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pi-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }
})();
